<template>
  <DatatableReportV3
    v-if="tenantLoaded"
    title="Job Times"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { mapGetters, mapState } from "vuex";

import MinutesLabel from "@/components/MinutesLabel.vue";
import CONSTANTS from "@/Constants.js";
import DepartmentLink from "@/Department/DepartmentLink.vue";
import JobTimesResultLabel from "@/Job/JobTimesResultLabel.vue";
import JobOpportunityLink from "@/Job/Opportunity/JobOpportunityLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";
const { NO_JOB_TIME_TOOLTIP_TEXT, NOT_AVAILABLE_JOB_TIME_TOOLTIP_TEXT } =
  CONSTANTS;

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      tenantLoaded({ tenant }) {
        return !!tenant;
      }
    }),
    ...mapGetters(["jobStatusEnabled"]),
    config() {
      return {
        columns: [
          { data: "first_appointment", title: "First Appt", searchable: false },
          { data: "job", title: "Job #", aggregateTitle: "# of Jobs" },
          {
            data: "job_status",
            title: "Job Status",
            filterName: "job_status_id",
            orderable: false,
            visible: this.jobStatusEnabled
          },
          { data: "invoice", title: "Invoice #" },
          { data: "customer", aggregateTitle: "# of Customers" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "location_name", title: "Location Name" },
          { data: "address", orderable: false },
          {
            data: "department",
            aggregateTitle: "# of Departments",
            filterName: "department_id"
          },
          {
            data: "opportunity_owner",
            title: "Opp Owner",
            filterName: "technician_id"
          },
          { data: "opportunity_status", title: "Opportunity" },
          {
            data: "appts",
            orderable: false,
            aggregateTitle: "# Appts",
            searchable: false
          },
          {
            data: "job_total",
            title: "Total",
            searchable: false,
            aggregateTitle: "Total",
            className: "text-right",
            footerClassName: "text-right"
          },
          {
            data: "job_total_time",
            title: "Total Time",
            searchable: false,
            className: "text-right",
            aggregateTitle: "Total Time",
            aggregateComponent: {
              rootId: "minutes-aggregate-vue",
              component: MinutesLabel,
              propName: "minutes", // name of component prop to pass in the aggregate value
              options: {
                props: {
                  defaultText: NO_JOB_TIME_TOOLTIP_TEXT,
                  notAvailableText: NOT_AVAILABLE_JOB_TIME_TOOLTIP_TEXT
                }
              }
            },
            footerClassName: "text-right",
            nullAggregate: true
          },
          {
            data: "job_sold_time",
            title: "Sold Time",
            className: "text-right",
            aggregateTitle: "Sold Time",
            searchable: false,
            aggregateComponent: {
              rootId: "minutes-aggregate-vue",
              component: MinutesLabel,
              propName: "minutes",
              options: {
                props: {
                  defaultText: NO_JOB_TIME_TOOLTIP_TEXT,
                  notAvailableText: NOT_AVAILABLE_JOB_TIME_TOOLTIP_TEXT
                }
              }
            },
            footerClassName: "text-right",
            nullAggregate: true
          },
          {
            data: "end_result",
            title: "End Result",
            filterName: "actual_time",
            searchable: false,
            aggregateTitle: "End Result",
            aggregateComponent: {
              rootId: "job-times-aggregate-vue",
              component: JobTimesResultLabel,
              propName: "minutes",
              options: {
                props: {
                  tableMode: true,
                  defaultText: NO_JOB_TIME_TOOLTIP_TEXT,
                  notAvailableText: NOT_AVAILABLE_JOB_TIME_TOOLTIP_TEXT
                }
              }
            },
            className: "text-right",
            footerClassName: "text-right",
            nullAggregate: true
          },
          {
            data: "efficiency_pct",
            title: "Job Eff.",
            aggregateTitle: "Job Eff.",
            className: "text-right",
            footerClassName: "text-right",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "department-modal-vue",
            component: DepartmentLink,
            options: {
              store
            }
          },
          {
            rootId: "job-opportunity-modal-vue",
            component: JobOpportunityLink,
            options: {
              store
            }
          },
          {
            rootId: "minutes-label-vue",
            component: MinutesLabel
          }
        ]
      };
    }
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Job Times" });
  }
};
</script>

<style lang="scss" scoped></style>
